module.exports = __webpack_public_path__ + "img/workBench4.0ca5bb81.png";